module.exports = __webpack_public_path__ + "static/media/user.c40fe570.svg";